"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageFingerPrinter = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsFingerPrinterTable = require("../../components/DmsFingerPrinter/DmsFingerPrinterTable");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageFingerPrinter Component
 * 
 * @description Component for importing finger printer table. Displays a DmsPage layout with a DmsFingerPrinterTable Product for managing finger print.
 * @description Component for managing and displaying finger prints within the system. 
 * Renders a DmsPage layout with a DmsAltBox containing the DmsFingerPrinterTable.
 * @component
 * @example
 * return (
      <DmsFingerPrinterTable/>
 * )
 * 
 * @returns {JSX.Element} The Finger Printer table page.
 */

const DmsPageFingerPrinter = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Finger printer"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("FingerPrinter").d("Finger printer"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsFingerPrinterTable.DmsFingerPrinterTable, null))));
};
exports.DmsPageFingerPrinter = DmsPageFingerPrinter;